import React, {useContext, useEffect} from 'react';
import * as PropTypes from 'prop-types';
import {ErrorBoundary} from "react-error-boundary";
import ClientError from "../../sections/client_error/ClientError";
import {getDriverRouteById, getDriverRouteObjectFromPath} from "./driverRoutes";
import {useLocation, useNavigate} from "react-router-dom";
import GlobalContext from "../../GlobalContext";


const PublicRoute = ({ children }) => {

    const globalData = useContext(GlobalContext);

    const navigate = useNavigate();

    const location = useLocation();

    // Set tab bar based on current path
    useEffect(() => {
        const currentPath = location.pathname;
        const currentRoute = getDriverRouteObjectFromPath(currentPath);
        if (currentRoute) {
            globalData.setCurrentRouteId(currentRoute.id ? currentRoute.id : null);   //update this section on public and secure routes
            globalData.setCurrentPath(currentRoute.path ? currentRoute.path: null);
            globalData.setVehicleHeader(currentRoute.vehicleHeader ? currentRoute.vehicleHeader : null);
            globalData.setVehicleHeaderTrans(currentRoute.vehicleHeaderTrans ? currentRoute.vehicleHeaderTrans : null);
            globalData.setCurrentTabBarId(currentRoute.tabBarId ? currentRoute.tabBarId : null);
            globalData.setCurrentBackRouteId(currentRoute.backRouteId ? currentRoute.backRouteId : null);
            globalData.setCurrentBackRouteTrans(currentRoute.backRouteTrans ? currentRoute.backRouteTrans : null);
            console.log('navigated (public) -> ' + currentPath + ' (vehicleHeader: ' + globalData.vehicleHeader + ', tabBarId: ' + globalData.currentTabBarId + ', backRouteId: ' + globalData.currentBackRouteId + ')');
        } else {
            console.log('navigated (public) -> ' + currentPath);
        }
    }, [location.pathname, globalData]);

    // Show page with error boundary (no login check as only public pages before login or that do not require login should get this route)
    return (
        <ErrorBoundary FallbackComponent={ClientError} onReset={() => navigate(getDriverRouteById('home'))}>
          {children}
        </ErrorBoundary>
    );
}

// Validate prop type parameters.
PublicRoute.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PublicRoute;
